<template>
    <div>
        <input type="checkbox" class="mobile-header-menu__sub-menu-checkbox" :id="'mobile-header-menu__sub-menu-' + _uid" name="mobile-menu" value="1" autocomplete="off" v-model="subMenuCheckbox" />
        <div class="mobile-menu__sub-menu">
            <div class="mobile-menu__scroll-area" ref="mobileScrollArea">
                <label :for="'mobile-header-menu__sub-menu-' + _uid" class="mobile-menu__sub-menu-link mobile-menu__back"> &larr; Back </label>
                <div class="mobile-menu__section" v-for="(subSection, subTitle) in content" :key="subTitle">
                    <ul class="mobile-menu__link-ul">
                        <li class="mobile-menu__link-li" v-for="(link, index) in subSection" :key="index">
                            <h4 v-if="link.h" class="mobile-menu__h4 mobile-menu--sub-title">
                                <a v-if="link.l" :href="link.l" class="mobile-menu__link mobile-menu--sub-title">{{ link.t }}</a>
                                <template v-else>{{ link.t }}</template>
                            </h4>
                            <a v-else :href="link.l" class="mobile-menu__link">{{ link.t }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <label :for="'mobile-header-menu__sub-menu-' + _uid" class="mobile-menu__sub-menu-link">
            {{ title }}
            <img src="/images/header/mobile-menu-arrow.svg" class="mobile-menu__sub-menu-arrow" />
        </label>
    </div>
</template>

<script>
    const bodyScrollLock = require('body-scroll-lock');

    export default {
        props: {
            title: {
                type: String,
                default: "",
                required: true,
            },
            content: {
                required: true,
            },
            mobileMenuOpen: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                subMenuCheckbox: false,
            };
        },
        watch: {
            subMenuCheckbox(newValue) {
                if (newValue == true) {
                    bodyScrollLock.disableBodyScroll(this.$refs['mobileScrollArea']);
                    return;
                }
                bodyScrollLock.enableBodyScroll(this.$refs['mobileScrollArea']);
            },
            mobileMenuOpen(newValue) {
                if (newValue == false) {
                    this.subMenuCheckbox = false;
                    return;
                }
            },
        },
        beforeDestroy() {
            bodyScrollLock.enableBodyScroll(this.$refs['mobileScrollArea']);
        },
    };
</script>

<style>
</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Layout/Menus/MobileSubMenu.vue